import ClaimGroupsListNavigationDefault from "@rd-web-markets/shared/dist/claim_group/ClaimGroupsListNavigationDefault";
export default ClaimGroupsListNavigationDefault;